import { render, staticRenderFns } from "./MembersDep.vue?vue&type=template&id=20901515&scoped=true&"
import script from "./MembersDep.vue?vue&type=script&lang=js&"
export * from "./MembersDep.vue?vue&type=script&lang=js&"
import style0 from "./MembersDep.vue?vue&type=style&index=0&id=20901515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20901515",
  null
  
)

component.options.__file = "MembersDep.vue"
export default component.exports